var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-card',[_c('span',{staticClass:"title"},[_vm._v("教师权限")])])}
var staticRenderFns = []

export { render, staticRenderFns }